import React from 'react';
import PropTypes from 'prop-types';

const TermsSection = ({ title, children, titleSize = 'large' }) => {
  const titleClasses = {
    large: 'text-[30px] font-semibold leading-[37px] text-[#101828] mb-6',
    medium: 'text-[24px] font-semibold leading-[30px] text-[#101828] mb-4',
  };

  return (
    <section className="mb-10">
      <h2 className={titleClasses[titleSize]}>{title}</h2>
      <div className="text-[18px] leading-7 text-[#475467]">
        {children}
      </div>
    </section>
  );
};

TermsSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  titleSize: PropTypes.oneOf(['large', 'medium']),
};

export default TermsSection;